'use strict';

import { setupImageFallback } from 'Util/imageUtils';

const selectors = {
    image: '.js-carousel-product-img',
    placeholder: '.js-product-tile-img-placeholder'
};

/**
 * Sets up image fallback handling in carousel product tiles.
 */
function initCarouselProductImageFallback() {
    const images = document.querySelectorAll(selectors.image);

    if (!images.length) return;

    setupImageFallback(images, selectors.placeholder);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselProductImageFallback);
} else {
    initCarouselProductImageFallback();
}
